import React from 'react';
import PropTypes from 'prop-types';

const IconImportant = ({ fill, className, width, height }) => (
    <svg
        className={`apc-svg-icon ${className}`}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
    >
        <path
            xmlns="http://www.w3.org/2000/svg"
            d="M27.306 40.217a3.327 3.327 0 0 1-2.281.87 3.419 3.419 0 0 1-2.314-.856c-.658-.57-.989-1.373-.989-2.4 0-.895.314-1.662.942-2.292.636-.63 1.403-.945 2.314-.945.914 0 1.691.314 2.33.945.636.63.97 1.397.97 2.292 0 1.013-.334 1.808-.972 2.386M22.919 9.75c.567-.561 1.25-.839 2.062-.839.813 0 1.502.278 2.077.839.57.561.859 1.239.859 2.036L27.08 28.02c0 .648-.2 1.15-.617 1.517-.414.37-.897.553-1.447.553a2.17 2.17 0 0 1-1.473-.542c-.416-.364-.627-.875-.627-1.528l-.834-16.233c0-.797.278-1.475.836-2.036M25 0C11.194 0 0 11.194 0 25s11.194 25 25 25 25-11.194 25-25S38.806 0 25 0"
            fill={fill}
        />
    </svg>
);

IconImportant.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconImportant.defaultProps = {
    fill: '#E47F00',
    className: '',
    width: 20,
    height: 20,
};

export default IconImportant;
